import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@front/shared/util-environment';
import { ID, Notification, User } from '../models/backend';
import { ClientData, Company } from '../stores/client-data.store';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private http = inject(HttpClient);
  environment = inject(ENVIRONMENT);
  readonly #NOTIFICATIONS_BASE_URL = `${this.environment.cmsApiUrl}/notification`;

  sendNotification(notification: Notification) {
    return this.http.post(`${this.#NOTIFICATIONS_BASE_URL}/email`, {
      data: notification,
    });
  }
}
